import React, { Component, ReactNode } from 'react';
import { Modal, Row, Button } from 'antd';
import { connect } from 'react-redux';
import Icon from '@ant-design/icons';

import { ReactComponent as CrossSVG } from '../../../assets/sightx-icons/svg/x-close.svg';
import { overrideSession } from '../../../slices/auth/refreshToken.thunks';
import { logoutSession } from '../../../slices/auth';
import styles from './sessionModal.module.scss';

interface SessionModalProps {
  overrideSession: () => void;
  logoutSession: () => void;
}

class SesionModal extends Component<SessionModalProps> {

  onLogout() {
    this.props.logoutSession();
  }

  onOverrideSession() {
    this.props.overrideSession();
  }
  render(): ReactNode {

    return (
      <Modal
        visible
        title="Open session"
        footer={null}
        className={styles.sessionModal}
        closeIcon={<Icon component={CrossSVG} />}
        onCancel={this.onLogout.bind(this)}
        centered
        maskClosable={false}
      >
        <p>You have logged into SightX from another device or browser. Click "Use Here" to continue with your session on this device/browser.</p>
        <Row justify="end" className={styles.actionWrapper}>
          <Button
            type="text"
            className={styles.logoutButton}
            onClick={this.onLogout.bind(this)}
          >
            Close
          </Button>
          <Button
            type="primary"
            className={styles.hereButton}
            onClick={this.onOverrideSession.bind(this)}
          >
            Use Here
          </Button>
        </Row>
      </Modal>
    );
  }
}

export default connect(null, {
  overrideSession,
  logoutSession
})(SesionModal);
